import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=add176c2&scoped=true&lang=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add176c2",
  null
  
)

export default component.exports